// src/components/ProgressStatus.tsx (renderProgressBar tweaked)
import React from "react";
import { Progress } from "components/ui/progress";

interface Props {
  transcriptProgress?: number | null;
  translationProgress?: number | null;
  speechProgress?: number | null;
  paymentLink?: string | null;
  jobStatus?: string | null;
}

export const ProgressStatus: React.FC<Props> = ({ transcriptProgress, translationProgress, speechProgress, paymentLink, jobStatus }) => {
  const allNull = transcriptProgress == null && translationProgress == null && speechProgress == null;
  if (allNull) {
    if (paymentLink) return (
      <a href={paymentLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
        waiting for payment
      </a>
    );
    return <span>waiting</span>;
  }

  const renderBar = (label: string, percent: number) => (
    <div className="mb-4">
      <p className="text-sm text-muted-foreground mb-1">{label}: {percent}%</p>
      <Progress value={percent} className="h-2" />
    </div>
  );

  // Treat 0 as "not started" so it does not mask another active stage.
  const inProg = (v?: number | null) => v != null && v > 0 && v < 100;
  const done = (v?: number | null) => v === 100;
  const isError = (v?: number | null) => v === -1;

  // Check for prepared to voiceover status
  if (jobStatus === "prepared_to_voiceover") {
    return <span className="text-purple-600">prepared to voiceover</span>;
  }

  if (isError(speechProgress))
    return <span className="text-red-600">speech generation error</span>;

  if (isError(translationProgress))
    return <span className="text-red-600">translation error</span>;

  if (isError(transcriptProgress))
    return <span className="text-red-600">transcription error</span>;

  if (done(translationProgress) && done(speechProgress)) return <span>translation and speech generation completed</span>;
  if (done(transcriptProgress)) return <span>transcript completed</span>;
  if (done(translationProgress)) return <span>translation completed</span>;
  if (done(speechProgress)) return <span>speech generation completed</span>;

  if (inProg(speechProgress)) return renderBar("Speech", speechProgress!);
  if (inProg(translationProgress)) return renderBar("Translation", translationProgress!);
  if (inProg(transcriptProgress)) return renderBar("Transcription", transcriptProgress!);

  return <span>waiting</span>;
};